module.exports = __webpack_public_path__ + "static/genasi-water-1-2c4fafb3c978d7795bc5c6c6490d4132.jpg";